import Bowser from 'bowser';

const _bowser = Bowser.getParser(window.navigator.userAgent);
const browser = _bowser.getBrowser();

export { browser };
